/*
 * @Description:
 * @Version: 1.0
 * @Autor: hekai
 * @Date: 2021-07-09 16:25:50
 * @LastEditors: hekai
 * @LastEditTime: 2021-07-09 16:27:29
 */
import {
  request
} from '@/utils/axios'

// 以下是请求接口范例代码，仅做示例
export function phoneLogin(data) {
  return request({
    url: '/user/phoneLogin',
    method: 'post',
    data
  })
}


export function accountLogin(data) {
  return request({
    url: '/app/v1/loginController/login',
    method: 'post',
    data
  })
}

// 查找
export function getDetailData(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bay/area/httpUtilsController/findByJson',
      method: 'post',
      data
    }).then(res => {
      resolve(res)
    }).catch((e) => {
      console.log(e)
      reject(e)
    })
  })
}

// 预览
export function getPreviewData(parameter) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bay/area/aggregateinformation/preview',
      method: 'get',
      params: parameter
    }).then(res => {
      resolve(res)
    }).catch((e) => {
      console.log(e)
      reject(e)
    })
  })
}

// 静态码id查找数据
export function getDetailDataById(data) {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/v1/area/staticInformation/detail/${data.id}`,
      method: 'get',
      data
    }).then(res => {
      resolve(res)
    }).catch((e) => {
      console.log(e)
      reject(e)
    })
  })
}

// 证书异常状态：根据产品区块链唯一编号查询静态信息列表
export function getStaticInformationList(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/bay/area/staticinformation/list',
      method: 'get',
      params: data
    }).then(res => {
      resolve(res)
    }).catch((e) => {
      console.log(e)
      reject(e)
    })
  })
}
